export default __webpack_public_path__ + "img/leapmotor-logo.6cb26efa.png";